import seed from '../../../shared/catalog.seed.json';
import type { CartLine, Catalog, Quote } from './types';

const API_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '');

// El catálogo se navega sin despertar al API (escala a cero): primero el JSON incluido en el build,
// después el del API cuando responde. El cobro sí depende del API.
export const bundledCatalog: Catalog = { shipping: seed.shipping, products: seed.products };

export async function fetchCatalog(): Promise<Catalog> {
  if (!API_URL) return bundledCatalog;
  const res = await fetch(`${API_URL}/catalog`);
  if (!res.ok) throw new Error('No se pudo cargar el catálogo');
  return (await res.json()) as Catalog;
}

export async function fetchQuote(lines: CartLine[], shipping: 'standard' | 'cdmx'): Promise<Quote> {
  if (!API_URL) throw new Error('El API no está configurado');
  const res = await fetch(`${API_URL}/checkout/quote`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ lines, shipping }),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? 'No se pudo calcular el total');
  }
  return (await res.json()) as Quote;
}

/** Despierta el contenedor en cuanto hay intención de compra, para que el pago no espere el arranque en frío. */
export function warmUp() {
  if (API_URL) void fetch(`${API_URL}/health`).catch(() => undefined);
}

export const mxn = (cents: number) =>
  (cents / 100).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
